import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogsBolseirosComponent } from './components/logs-bolseiros/logs-bolseiros.component';
import { LogsProfissionaisComponent } from './components/logs-profissionais/logs-profissionais.component';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';

@Component({
  selector: 'app-registos',
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    LogsBolseirosComponent,
    LogsProfissionaisComponent,
    SearchBarComponent
  ],
  templateUrl: './registos.component.html',
  styleUrl: './registos.component.scss'
})
export class RegistosComponent {
  selectedOption: string | null = null;
  options = [
    { label: 'Registos de Profissionais', value: 'profissionais' },
    { label: 'Registos de Bolseiros', value: 'bolseiros' },
  ];
}

